// USER
export const CREATE_USER_SUCCESS = "CREATE_USER_SUCCESS";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILURE = "LOGIN_FAILURE";
export const IS_LOGINLOADING = "IS_LOGINLOADING"
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const SHOW_LOADER = "SHOW_LOADER";
export const HIDE_LOADER = "HIDE_LOADER";

